// extracted by mini-css-extract-plugin
var _1 = "ListTableFooter_footerCell__7LV+o";
var _2 = "ListTableFooter_footerRow__zzN07";
export { _1 as "footerCell", _2 as "footerRow" }
